import { render, staticRenderFns } from "./RetailerSelectionComponent.vue?vue&type=template&id=5d6fe1a1"
import script from "./RetailerSelectionComponent.vue?vue&type=script&lang=ts"
export * from "./RetailerSelectionComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports